import VisibilityTracker from '../../../lib/visibilityTracker';

const trackVisibility = function(trackedElement, observerOptions = {}) {
  if (!trackedElement || trackedElement.dataset.trackVisibility != 'true')
    return;

  const tracker = new VisibilityTracker(trackedElement, observerOptions);
  return function(elementVisibleCallBack) {
    tracker.track(elementVisibleCallBack);
    return tracker;
  };
};

const trackVisibleElementCallback = function(eventName) {
  return function() {
    // eslint-disable-next-line no-undef
    Sofatutor.trackGa4GeneralEvent(eventName);
  };
};

function callTrackers(learningTextTracker, learningTextCompletelySeenTracker) {
  learningTextTracker &&
    learningTextTracker(trackVisibleElementCallback('learningtext_seen'));
  learningTextCompletelySeenTracker &&
    learningTextCompletelySeenTracker(
      trackVisibleElementCallback('learningtext_complete_seen')
    );
}

document.addEventListener('DOMContentLoaded', function() {
  let descriptionAccordion = document.querySelector(
    'div.videos-description-accordion'
  );
  let learningTextElementParent =
    document.querySelector('.videos-content-tab__content--description') ||
    descriptionAccordion;
  let learningTextElement =
    learningTextElementParent &&
    learningTextElementParent.querySelector('.markdown > h2');

  let learningTextEndMarkerElement = document.querySelector(
    '.video-content--description-end'
  );

  if (learningTextElement && learningTextEndMarkerElement) {
    learningTextElement.dataset.trackVisibility =
      learningTextElementParent.dataset.trackVisibility;

    const learningTextTracker = trackVisibility(learningTextElement);
    const learningTextCompletelySeenTracker = trackVisibility(
      learningTextEndMarkerElement
    );

    if (descriptionAccordion) {
      callTrackers(learningTextTracker, learningTextCompletelySeenTracker);
    } else {
      document.querySelectorAll('.videos-content-tab__card').forEach(card => {
        card.addEventListener('click', function(event) {
          let learningTextTabActive = event.target.closest(
            '.videos-content-tab__card--description'
          );

          if (learningTextTabActive) {
            callTrackers(
              learningTextTracker,
              learningTextCompletelySeenTracker
            );
          }
        });
      });
    }
  }
});
